import React from 'react';
import { ResearchContextProvider } from './ResearchContext.provider';
import ResearchComponent from './Research.jsx';
import ShareComponent from './Share.jsx';

export type ResearchProps = {
  type?: string;
  [key: string]: any;
};

const Research: React.FC<ResearchProps> = ({ type = 'research', ...otherProps }) => {
  return (
    <ResearchContextProvider>
      { type === 'research' ? <ResearchComponent {...otherProps} /> : <ShareComponent {...otherProps} /> }
    </ResearchContextProvider>
  );
};

export default Research;
